module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-marquee-2-image-1-1-0de974a2cebeff03402104ce878d4e35.png";